export const keywords = [
  // Major Companies and Products
  'Neural DSP',
  'NDSP',
  'IK Multimedia',
  'Tonex',
  'Line 6',
  'Helix',
  'Positive Grid',
  'Bias',
  'Overloud',
  'THU',
  'Native Instruments',
  'Guitar Rig',
  'ML Sound Lab',
  'Kuassa',
  'STL Tones',
  'STL',
  'Amphub',
  'Tonehub',
  'Josh Middleton',
  'Audio Assault',
  'Amp Locker',
  'LePou',
  'Nalex',
  'Ignite Amps',
  'Kazrog',
  'Mercuriall Audio',
  'Mercuriall',
  'Nembrini Audio',
  'Nembrini',
  'Two Notes',
  'Lancaster Audio',

  // Specific Products
  'AXP Flextron',
  'AXP SoftAmp GT',
  'AXP',
  'Ampskin Amp Sims',
  'Ampskin',
  'Apple Logic Amp Designer',
  'Audified ampLion Pro',
  'Audio Assault AHM 5050',
  'Audio Assault',
  'Audio Assault Bass Grinder',
  'Audio Assault Dominator',
  'Audio Assault Grind Machine II',
  'Audio Assault HellBeast',
  'Audio Assault KLANK',
  'Audio Assault RVXX',
  'Audio Assault Sigma',
  'Audiority Blue Face',
  'Audiority L12X',
  'Audiority Solidus VS8100',
  'Audiority Dr Drive',
  'Aurora DSP Mammoth',
  'Aurora DSP Mr. Hector',
  'Aurora DSP Rhino',
  'Avid Eleven Mk II',
  'Black Rooster Audio Cypress TT-15',
  'Black Rooster Audio VPRE-73',
  'Blue Cat Axiom',
  'Blue Cat Destructor',
  'Blue Cat Free Amp',
  'Brainworx bx_bassdude',
  'Brainworx',
  'Brainworx bx_blackdist',
  'Brainworx bx_friedman BE100',
  'Brainworx bx_friedman DS40',
  'Brainworx bx_megadual',
  'Brainworx bx_megasingle',
  'Brainworx bx_rockergain100',
  'Brainworx bx_rockrack V3',
  'Brainworx bx_soldano SLO100',
  'Chandler GAV19T by Universal Audio',
  'ChowAmp',
  'ChowCentaur',
  'Crunck V2',
  'Deplike Amp Sim',
  'ENGL Savage 120 by Universal Audio',
  'Universal Audio',
  'FREEAMP 3.6',
  'Friedman BE-100 by Universal Audio',
  'Headrush Gigboard',
  'IK Multimedia AmpliTube 4',
  'IK Multimedia AmpliTube 5',
  'Ignite Amps 3rd Party Plugin Ports',
  'Ignite Amps Emissary',
  'Ignite Amps NRR-1',
  'Ignite Amps ProF.E.T.',
  'Ignite Amps SHB-1',
  'Ignite Amps TSB-1 Tyrant Screamer',
  'Ignite Amps The Anvil',
  'Ignite NadIR',
  'Klevgrand Stark Amp Simulator',
  'Kuassa Amplifikation 360',
  'Kuassa Amplifikation Caliburn',
  'Kuassa Amplifikation Clarent',
  'Kuassa Amplifikation Creme',
  'Kuassa Amplifikation Lancaster',
  'Kuassa Amplifikation Lite',
  'Kuassa Amplifikation Matchlock',
  'Kuassa Amplifikation Rectifor',
  'Kuassa Amplifikation VVV',
  'Kuassa Amplifikation Vermilion',
  'L12X Solid State',
  'LePou Le456',
  'LePou Plexi',
  'Line 6 Helix Native',
  'Line 6 POD Farm 2.5',
  'ML Sound Lab Amped - All Access Suite',
  'ML Sound Lab Amped 5151',
  'ML Sound Lab Amped Barba',
  'ML Sound Lab Amped Bass',
  'ML Sound Lab Amped Cali',
  'ML Sound Lab Amped Dual',
  'ML Sound Lab Amped Flagship',
  'ML Sound Lab Amped ML5',
  'ML Sound Lab Amped Roots',
  'ML Sound Lab Amped Stevie T',
  'Marshall Plexi Super Lead 1959 by Universal Audio',
  'MeldaProduction MGuitarArchitect',
  'Mercuriall Ampbox',
  'Mercuriall Cab',
  'Mercuriall Euphoria',
  'Mercuriall Greed Smasher',
  'Mercuriall MT-A',
  'Mercuriall ReAxis',
  'Mercuriall SS-11X',
  'Mercuriall Spark',
  'Mercuriall Tube Amp Ultra 530',
  'Mercuriall U530',
  'Native Instruments Guitar Rig 6 Pro',
  'Native Instruments Guitar Rig 7 Pro',
  'Nembrini Audio 8180',
  'Nembrini Audio BST100',
  'Nembrini Audio Faceman',
  'Nembrini Audio IR Loader',
  'Nembrini Audio JMP Pro',
  'Nembrini Audio MRH159',
  'Nembrini Audio MRH810',
  'Nembrini Audio Sound Master Custom Tube Guitar Amplifier',
  'Nembrini Audio Voice DC30',
  'Neural DSP Archetype: Abasi',
  'Neural DSP',
  'Neural DSP Archetype: Cory Wong',
  'Neural DSP Archetype: Gojira',
  'Neural DSP Archetype: Nolly',
  'Neural DSP Archetype: Petrucci',
  'Neural DSP Archetype: Plini',
  'Neural DSP Archetype: Rabea',
  'Neural DSP Archetype: Tom Morello',
  'Neural DSP Fortin Cali Suite',
  'Neural DSP Fortin NTS Suite',
  'Neural DSP Fortin Nameless Suite',
  'Neural DSP Mesa Boogie Mark IIC+ Suite',
  'Neural DSP Omega Ampworks Granophyre',
  'Neural DSP Soldano SLO-100 Suite',
  'Neural DSP Tone King Imperial MKII',
  'Nick Crow Labs 7150',
  'Nick Crow Labs 8505',
  'Overloud TH-3',
  'Overloud TH-U',
  'Peavey ReValver 4',
  'Positive Grid BIAS Amp 2',
  'Positive Grid BIAS FX 2',
  'Positive Grid BIAS FX Elite',
  'PreSonus Ampire',
  'Revalver 4',
  'STL Ignite Emissary Bundle',
  'STL Tones AmpHub',
  'STL Tones Andy James Signature',
  'STL Tones Howard Benson',
  'STL Tones ToneHub',
  'STL Tones Will Putney Signature',
  'Scuffham S-Gear',
  'Shattered Glass Audio Ace Amp',
  'Shattered Glass Audio SGA1566',
  'Softube Amp Room',
  'Softube Metal Amp Room',
  'Softube Vintage Amp Room',
  'Studio Devil Amp Modeler Pro',
  'Studio Devil British Valve Custom',
  'TSE BOD',
  'TSE R47',
  'TSE X30',
  'TSE X50 v2',
  'ToneLib GFX',
  'Tonelib BassDrive',
  'Tonelib Metal',
  'Tracktion DAW Essentials Guitar Amp Sim',
  'VHT Deliverance by Universal Audio',
  'ValhallaDSP VintageVerb',
  'Vox AmPlug Studio',
  'Voxengo Boogex',
  'Waves CLA Guitars',
  'Waves GTR3',
  'Waves PRS SuperModels',
  'Waves Voltage Amps',
  'Xhun Audio IronAxe',
  'Zoom Guitar Lab',
  'bx_rockrack V3 Player',
  'UAD',
  'Polychrome DSP',
];
